import React from 'react';
import { Row, Col, Button } from 'antd';
import { FaPlus } from 'react-icons/fa';
import StripeCheckout from 'react-stripe-checkout';

export interface EmptyContainerProps {
  title: string;
  icon: string;
  onClick?: any;
}

export const EmptyContainer: React.FC<EmptyContainerProps> = ({
  title,
  icon,
  onClick,
}) => {
  return (
    <Row className="empty-meals-container" justify="center">
      <Col span={24} className="empty-meals-wrapper">
        <img src={icon} alt="meals" />
        <span>{title}</span>
      </Col>
      {onClick && (
        <div className="floating-button">
          {/* <StripeCheckout
            stripeKey="pk_test_51HjNYSJ5WQFrUpTvfycUGRD2gzhqTdVGpWbdcuK7xl3kUJJizWRhXj7dpiBYpzLrllI0ALdCfgwldNS640qskfSP00TejEqust"
            token={onClick}
            name="Add Your Card"
            panelLabel="Add"
          > */}
          <Button shape="circle" size="large" onClick={onClick}>
            <FaPlus size={14} />
          </Button>
          {/* </StripeCheckout> */}
        </div>
      )}
    </Row>
  );
};

export const EmptyAddCard: React.FC<EmptyContainerProps> = ({
  title,
  icon,
  onClick,
}) => {
  return (
    <Row className="empty-meals-container" justify="center">
      <Col span={24} className="empty-meals-wrapper">
        <img src={icon} alt="meals" />
        <span>{title}</span>
      </Col>
      {onClick && (
        <div className="floating-button">
          <StripeCheckout
            stripeKey="pk_test_51HjNYSJ5WQFrUpTvfycUGRD2gzhqTdVGpWbdcuK7xl3kUJJizWRhXj7dpiBYpzLrllI0ALdCfgwldNS640qskfSP00TejEqust"
            token={onClick}
            name="Add Your Card"
            panelLabel="Add"
          >
            <Button shape="circle" size="large">
              <FaPlus size={14} />
            </Button>
          </StripeCheckout>
        </div>
      )}
    </Row>
  );
};
